export type AlmeIvaTypeProp = 'embedded' | 'popup' | 'inline';

interface AlmeIvaTypeStyles extends Record<string, unknown> {
    ivaType?: AlmeIvaTypeProp;
    children?: React.ReactNode;
}

type AlmeIvaTypeMapping = Record<AlmeIvaTypeProp | string, unknown>;

export const styledBy = (property: string, mapping: AlmeIvaTypeMapping) => (props: AlmeIvaTypeStyles): string | undefined => {
    return mapping[props[property] as string || 'embedded'] as string | undefined;
};
